import React from 'react';
import Sorting from '../../views/Sorting';
import Cookies from 'js-cookie';
import '../../css/regokas.css';
import _ from 'lodash';
import { sort } from 'react-icons-kit/fa/sort';
import Loader from '../../components/loader';
import Edit from '../../images/headericon/Edit.svg';
import Delete from '../../images/headericon/Delete.svg';
import { cancelCircle } from 'react-icons-kit/icomoon/cancelCircle';
import Success from '../../images/Success.svg';
import Error from '../../images/Error.svg';
import Delete1 from '../../images/headericon/deletedeactive.svg';
import errorText from '../../errorText';
import SearchBar from '../../views/SearchBar';
import Style from 'style-it';
import IntegrationReactSelectNew from '../../views/IntegrationReactSelectNew';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    IconButton,
} from "@mui/material";
import { connect } from 'react-redux';
import * as ActionTypes from '../../actions/types';
import { AiOutlinePlus } from 'react-icons/ai';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { Box } from '@mui/system';
import { is_allowed } from '../../utils';


class Memberlicense extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            okasInventoryData: [],
            okasBoxDatalocation: [],
            memberLicenseData: [],
            siData: [],
            kk: 'asdvhj',
            okasBox_type: '',
            okasBox_serialNo: '',
            okasBox_version: '',
            user: '',
            created_at: '',
            selectedBoxes: [],
            // selectedSi: [],
            selectedSi: '',
            si_id: '',
            okasBox_id: [],
            memberLicenses: [],
            error: '',
            nameerror: '',
            namess: '',
            sortedType: '',
            searchValue: '',
            actualdata: [],
            disabledvalue: '',
            successmsgmodaldata: localStorage.getItem('dataadded'),
            showmodels: '',
            showmodels1: '',
            loader: '',
            passwordi: false,
            currentPage: 1,
            todosPerPage: 10,
            statuson: false, statustw: false, statusth: false,
            statusfo: false, statusfi: false, statussi: false,
            statusse: false, statusei: false, statusni: false,
            statuste: false,
            disableAddButton: false,
            confirmWindow: false,
            projectManagerToDelete: '',
            pagemode: ''

        };
        this.handleClickpage = this.handleClickpage.bind(this);
    }



    crosserrorfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            error: '',
        })

    }

    // confirmWindowClose = () => {
    //     this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

    //     this.setState({
    //         confirmWindow: false
    //     })
    // }

    // oncolseClickHandler = (event) => {
    //     this.setState({
    //         si_name: '',
    //         si_mobile: '',
    //         si_email: '',
    //         si_company: '',
    //         si_address: '',
    //         si_area: '',
    //         si_description: '',
    //         si_rating: '',
    //         si_relationstatus: '',
    //         si_gstin: '',
    //         si_type: '',
    //     })
    //     this.onclosemodel1()
    // }

    componentWillMount() {
    }

    errormsg = () => {
        setTimeout(
            function () {
                localStorage.removeItem('dataadded');
                this.setState({
                    successmsgmodaldata: '',
                    error: '',
                })
            }
                .bind(this), 3000
        );
    }

    crosssuccessfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            successmsgmodaldata: '',
        })
    }

    componentDidMount() {
        this.getallrealdata();
    }

    getallrealdata = () => {
        this.setState({
            loader: true,
        })
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch(`/we/we/members_license/`, {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(memberLicenseData => {
                this.setState({
                    memberLicenseData: memberLicenseData.data,
                    actualdata: memberLicenseData.data
                }, () => {
                    this.renderTableData();
                })
                console.log(this.state.memberLicenseData)
                this.setState({
                    loader: false,
                })
            })

        fetch('/we/we/addSI/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(siData => {
                this.setState({
                    siData,
                    actualdata: siData
                }, () => {
                    this.renderTableData();
                    // console.log(this.state.actualdata)
                })
                this.setState({
                    loader: false,
                })
            })


        // fetch('/we/we/locationApi/', {
        //     method: "GET",
        //     headers: headers
        // })
        //     .then(response => response.json())

        //     .then(okasBoxDatalocation => {
        //         this.setState({
        //             okasBoxDatalocation
        //         }, () => {
        //             this.renderTableDatalocation();
        //             this.renderLocation();
        //             console.log(this.state.okasBoxDatalocation);
        //         })
        //     })
    }



    renderTableDatalocation = (type) => {
        if (type === 'location') {
            var typee = 0;
            let xx = this.state.okasBoxDatalocation.map((e, index) => {
                // console.log(e)
                typee = typee + 1;
                return (
                    <option key={index} value={e.ID}>{e.location}</option>
                )
            });
            return xx;
        }
    }

    renderLocation = () => {
        let LocationData = [];
        if (Array.isArray(this.state.okasBoxDatalocation)) {
            this.state.okasBoxDatalocation.forEach((e) => {
                LocationData.push({
                    label: e.location,
                    value: e.ID.toString()
                });
            });
            this.setState({
                LocationData: LocationData
            });
        } else {
            return null;
        }
    }


    handleClickpage(event, position) {
        let pageNo = 0;
        if (position === 'position') {
            pageNo = event
        } else {
            pageNo = event.target.id
        }
        this.setState({
            currentPage: Number(pageNo)
        });
        this.renderTableData('type1');
        this.renderTableData('pagination');
    }

    handleCheckboxChange = (boxId) => {
        const { selectedBoxes } = this.state;
        const index = selectedBoxes.indexOf(boxId);

        if (index === -1) {
            this.setState((prevState, id) => ({
                selectedBoxes: [...prevState.selectedBoxes, boxId],

                memberLicenses: [...prevState.memberLicenses, boxId],
            }));
        } else {
            const updatedSelectedBoxes = [...selectedBoxes];
            updatedSelectedBoxes.splice(index, 1);

            this.setState({
                selectedBoxes: updatedSelectedBoxes,

                memberLicenses: updatedSelectedBoxes,
            });
        }
    };

    handleRadioSiChange = (siId) => {
        this.setState({
            selectedSi: siId,
            si_id: siId,
        });
    };

    // handleRadioSiChange = (siId) => {
    //     const { selectedSi } = this.state;
    //     const index = selectedSi.indexOf(siId);

    //     if (index === -1) {
    //       this.setState((prevState) => ({
    //         selectedSi: [...prevState.selectedSi, siId],
    //       }), () => {
    //         console.log("selected", this.state.selectedSi);
    //       });
    //     } else {
    //       const updatedSelectedBoxes = [...selectedSi];
    //       updatedSelectedBoxes.splice(index, 1);

    //       this.setState({
    //         selectedSi: updatedSelectedBoxes,
    //       }, () => {
    //         console.log("updated", this.state.selectedSi);
    //       });
    //     }
    // };

    renderTableData = (type) => {
        if (this.state.memberLicenseData.detail == 'Invalid token.') {
            localStorage.removeItem('auth');
            localStorage.removeItem('username');
            this.props.history.push('/login')
        }

        let indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
        let indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
        let currentTodos = this.state.memberLicenseData.slice(indexOfFirstTodo, indexOfLastTodo);
        let currentSi = this.state.siData.si_data;


        if (type === 'pagination') {
            let pageNumbers = [];
            for (let i = 1; i <= Math.ceil(this.state.memberLicenseData.length / this.state.todosPerPage); i++) {
                pageNumbers.push(i);
            }
            let renderPageNumbers = pageNumbers.map((number, i) => {
                if ((this.state.currentPage - 3 < i + 1) && ((this.state.currentPage + 3 > i + 1 || 6 > i + 1))) {
                    return (
                        <li className={this.state.currentPage == number ? "active" : null}><a id={number} onClick={this.handleClickpage}>{number}</a></li>
                    );
                }
            });
            return renderPageNumbers;
        }

        if (type === 'type1') {
            var typee = 0;
            let xx = currentTodos.map((e, index) => {
                const dateFromString = new Date(e.modified);
                const dateOnly = dateFromString.toISOString().split('T')[0];
                typee = typee + 1;
                return (
                    <tr key={index}>
                        <td style={{ textAlign: 'center' }} className={this.props.windowWidth > 835 ? "qwerty" : ""}>
                            {is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "member licence", "assign") && <input
                                type="checkbox"
                                name={e.okasBox_type}
                                onChange={() => this.handleCheckboxChange(e.id)}  // memberLicence id
                                disabled={e.status !== "Assigned Distributor"}
                                checked={this.state.selectedBoxes.includes(e.id)} // memberLicence id
                            />}
                        </td>
                        <td style={{ textAlign: 'center' }} className={this.props.windowWidth > 760 ? "qwerty" : ""}>{(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + index + 1}</td>

                        <td >{e.licenseNo}</td>
                        {/* <td >{e.email}</td> */}
                        <td>
                            {e.status !== 'Assigned Distributor' && <span>{e.email}</span>}
                        </td>
                        <td style={{ color: e.status === 'Assigned Distributor' ? 'red' : (e.status === 'Assigned Project' ? 'green' : '#f07e25') }}>
                            {e.status === 'Assigned Distributor' ? 'UNASSIGNED' : e.status.toUpperCase()}
                        </td>


                        {/* <td>{e.modified.substring(0, 10) + ' ' + e.modified.substring(11, 19)}</td> */}
                        <td>{dateOnly}</td>

                    </tr>
                )
            });
            return xx;
        }

        if (type === 'siSelect') {
            var typee = 0;
            let xx = currentSi.map((e, index) => {
                typee = typee + 1;
                return (
                    <tr key={index}>
                        <td className="config-table">{e.si_name}</td>
                        <td className="config-table">{e.si_area}</td>
                        <td className="config-table">{e.si_mobile}</td>
                        <td className="config-table">{e.si_email}</td>
                        <td className="config-table">
                            <input
                                type="radio"
                                name={e.si_name}
                                checked={this.state.selectedSi === e.si_id}
                                onChange={() => this.handleRadioSiChange(e.si_id)}
                            />
                        </td>
                    </tr>
                )
            });
            return xx;
        }
    }



    onopenmodel = (event) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

        this.setState({
            showmodels: 'true',
            pagemode: ''
        });
        const selectedBoxIds = this.state.selectedBoxes.join(', ');
        const totalSelected = this.state.selectedBoxes.length;
        const modalTitle = selectedBoxIds
            ? `Assign ${totalSelected} Member License${totalSelected > 1 ? 's' : ''} to`
            : 'Assign Member License';
        // const modalTitle = selectedBoxIds ? `Assign Member License ${selectedBoxIds} to` : 'Assign Member License';

        this.setState({
            modalTitle: modalTitle,
        });
        this.props.searchBarActivate(false)
    }

    onclosemodel = (event) => {
        this.setState({
            showmodels: '',
        })
    }

    onAssignSiClosemodel = (event) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            showmodels: '',
            si_id: '',
            okasBox_id: [],
            id: '',
            memberLicenses: [],
            disableAddButton: false,
            selectedBoxes: [],
            selectedSi: '',
        })
    }





    onAddClickHandler = (buttonaction) => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken'),
        }

        const { si_id, memberLicenses } = this.state;

        if (si_id && memberLicenses) {
            this.setState({
                disabledvalue: 'disabled',
                loader: true
            });

            let tt = {
                si_id: si_id,
                memberLicenses: memberLicenses,
            };

            fetch('/we/we/members_license/', {
                method: "PUT",
                headers: headers,
                body: JSON.stringify(tt)
            })
                .then(response => response.json())
                .then(data => {
                    // console.log('Response from server:', data);
                    this.setState({
                        loader: false,
                        disabledvalue: ''
                    });

                    if (data.message === "success" && buttonaction === 'add') {
                        this.setState({
                            successmsgmodaldata: 'dataadded',
                            successmodalstates: 'add',
                        });
                        this.getallrealdata();
                        alert('Member Licence Successfully Assign To System Integrator!');
                        this.onAssignSiClosemodel();
                        this.errormsg();
                    } else {

                        alert('Unable to assign Member Licence to System Integrator!');
                        return null;
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                    this.setState({
                        loader: false,
                        disabledvalue: ''
                    });
                    alert('An error occurred while processing the request.');
                });
        }
    }






    restoreData = (data) => {
        this.setState({
            memberLicenseData: data,
        })
    }


    sortingFunc = (type, searchValue) => {


        if (type !== "search") {
            this.props.searchBarActivate(false)
        }

        if (type == "okasBox_type") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statuson: !this.state.statuson,
            })
        }
        if (type == "okasBox_serialNo") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statuson: !this.state.statuson,
            })
        }
        if (type == "okasBox_version") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statustw: !this.state.statustw,
            })
        }
        if (type == "user") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        }
        if (type == "created_at") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        }


        if (this.state.sortedType !== type && type !== 'search') {
            this.setState({
                sortedType: type
            })
            Sorting(this.restoreData, type, this.state.memberLicenseData);
        } else if (type === 'search') {
            type = 'search';
            Sorting(this.restoreData, type, this.state.actualdata, searchValue);
        } else {
            type = 'reverse';
            Sorting(this.restoreData, type, this.state.memberLicenseData);
        }
    }




    // onSearchClick = () => {
    //     this.props.searchBarActivate(!this.props.redux.globalVar.searchBarShow)
    // }

    onSelectChange = (operationMode, valueSelect) => {
        if (valueSelect.label !== undefined) {
            this.setState({
                [operationMode]: valueSelect.value,
                error: false,
                locationerror: false,
            })

        }
    }


    render() {
        return Style.it(`
        @media only screen and (max-width: 760px){
      td:nth-of-type(1):before { content: ""; }
      td:nth-of-type(2):before { content: "S.NO"; }
      td:nth-of-type(3):before { content: "MEMBER LICENSE"; }
      td:nth-of-type(4):before { content: "EMAIL"; }
      td:nth-of-type(5):before { content: "STATUS"; }
      td:nth-of-type(6):before { content: "DATE OF PURCHASE"; }
            
      
      td.config-table:nth-of-type(1):before { content: "System Integrator Name"; }
      td.config-table:nth-of-type(2):before { content: "Area"; }
      td.config-table:nth-of-type(3):before { content: "Mobile No"; }
      td.config-table:nth-of-type(4):before { content: "Email"; }
      td.config-table:nth-of-type(5):before { content: " "; }
      
    }`, <div>
            <ToastContainer />
            <div className="selfcontainer"
                style={{
                    position: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "fixed" : "absolute",
                    overflow: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "hidden" : "",

                }}

            >
                <ToastContainer />
                {this.state.loader ? <Loader /> : null}

                {this.props.redux.globalVar.searchBarShow ?
                    <div className='row searchinput'>
                        <SearchBar
                            autoFocus
                            value={this.state.searchValue}
                            onChange={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', this.state.searchValue)
                                })
                            }
                            }
                            onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
                            resetSearch={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', '')
                                })
                            }}
                        />
                    </div>
                    : ''}

                {this.state.showmodels ?
                    <div className="selfmodal fade" id="mastercontrollerbox" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                        <div className="selfmodal-dialog"
                            style={{
                                width: this.props.windowWidth > 835 ? "50%" : "95%",


                            }}
                        >
                            <div className="selfmodal-content" style={{ marginTop: "100px", width: '70%', margin: 'auto' }}>
                                <div className="modal-header" >
                                    <button type="submit" className="close" data-dismiss="modal"
                                        onClick={this.onAssignSiClosemodel.bind(this)}
                                    >&times;</button>
                                    <h3 className="modal-title">{this.state.modalTitle} </h3>
                                </div>
                                <div className="modal-body"  >
                                    <TableContainer component={Paper} className={this.props.windowWidth > 760 ? "table table-striped tablecontent" : "mobile-device-margin-zero"} id="example">
                                        <Table className={"tablecontent"}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ color: 'white', fontSize: '11px' }}>SI Name</TableCell>
                                                    <TableCell sx={{ color: 'white', fontSize: '11px' }}>Area</TableCell>
                                                    <TableCell sx={{ color: 'white', fontSize: '11px' }}>Mobile No.</TableCell>
                                                    <TableCell sx={{ color: 'white', fontSize: '11px' }}>Email</TableCell>
                                                    <TableCell></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.renderTableData("siSelect")}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                                <br />

                                <div className="modal-footer">
                                    <React.Fragment>
                                        <button type="button"
                                            onClick={this.onAssignSiClosemodel.bind(this)}
                                            className="btn allbtn" data-dismiss="modal">
                                            Cancel
                                        </button>
                                        <button type="submit" disabled={this.state.disabledvalue ? this.state.disabledvalue : null}
                                            onClick={this.onAddClickHandler.bind(this, 'add')}
                                            className="btn allbtn" style={{ backgroundColor: '#4286f5' }} data-dismiss="modal">
                                            Add
                                        </button>
                                    </React.Fragment>
                                </div>
                            </div>
                        </div>
                    </div>

                    : null}

                <div className="addregOkasButton" >
                    {this.state.selectedBoxes.length > 0 && (
                        // <a className="addregOkasButtonicon button-custom-height-size" data-toggle="modal" data-target="#myModal" onClick={this.onopenmodel.bind(this)}>
                        //     <AiOutlinePlus size={42} style={{ color: " #15599F" }} />
                        //     <span className="hidden-xs hidden-sm button-color">Assign To System Integrator</span> </a>
                        <Box
                            component="a"
                            href="#myModal"
                            className="addregOkasButtonicon button-custom-height-size"
                            onClick={this.onopenmodel.bind(this)}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: "#f9f9f9",
                                color: "#94979a",
                                textTransform: "none",
                                padding: "10px 20px",
                            }}
                        >
                            <AiOutlinePlus size={30} style={{ marginRight: 8, color: "#15599F" }} />
                            <span className="hidden-xs hidden-sm button-color">Assign To System Integrator</span>
                        </Box>
                        // <div className="hidden-xs hidden-md  hidden-lg button-color sm-heading-btn">Assign To System Integrator</div>
                    )}
                </div>

                <div className="row">
                    <h3 className="sentence-case">{this.props.redux.globalVar.reUserNameStyle}'s Member License Request</h3>
                    <h6 className="mb-3 mt-0">Find the comprehensive view and details of all the member licenses request from system integrator.</h6>
                    {/* <div className={this.state.successmsgmodaldata ? 'successmsgbox' : 'successmsgbox successmsgboxnone'}  >
                        <div className="inblksuccfull"><img src={Success} /></div>
                        <div className="inblksucc1">
                            SUCCESS !
                            <a className="successmsgcross"><Icon icon={cross} size={20} onClick={(e) => { this.crosserrorfullmsg(this) }} /></a>
                        </div>
                    </div> */}

                    <div className="tests" onContextMenu={(e) => { e.preventDefault(); }}>
                        <TableContainer component={Paper} className={this.props.windowWidth > 760 ? "table table-striped tablecontent" : "mobile-device-margin-zero"} id="example">
                            <Table className={"tablecontent"}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ width: this.props.windowWidth > 835 ? "5%" : "10%" }}></TableCell>
                                        <TableCell style={{ width: this.props.windowWidth > 835 ? "10%" : "10%", color: 'white', fontSize: '11px', textAlign: 'center' }}>S.No</TableCell>
                                        <TableCell style={{ width: this.props.windowWidth > 835 ? "28%" : "20%", color: 'white', fontSize: '11px' }}>
                                            MEMBER LICENSE
                                            {this.state?.statuson ? (
                                                <IoIosArrowUp size={16} className="pull-right" onClick={() => this.sortingFunc("okasBox_type", "")} />
                                            ) : (
                                                <IoIosArrowDown size={16} className="pull-right" onClick={() => this.sortingFunc("okasBox_type", "")} />
                                            )}
                                        </TableCell>
                                        <TableCell style={{ width: this.props.windowWidth > 835 ? "20%" : "25%", color: 'white', fontSize: '11px' }}>
                                            EMAIL
                                            {this.state?.statusth ? (
                                                <IoIosArrowUp size={16} className="pull-right" onClick={() => this.sortingFunc("okasBox_version", "")} />
                                            ) : (
                                                <IoIosArrowDown size={16} className="pull-right" onClick={() => this.sortingFunc("okasBox_version", "")} />
                                            )}
                                        </TableCell>
                                        <TableCell style={{ width: this.props.windowWidth > 835 ? "16%" : "15%", color: 'white', fontSize: '11px' }}>
                                            STATUS
                                            {this.state?.statusfo ? (
                                                <IoIosArrowUp size={16} className="pull-right" onClick={() => this.sortingFunc("user", "")} />
                                            ) : (
                                                <IoIosArrowDown size={16} className="pull-right" onClick={() => this.sortingFunc("user", "")} />
                                            )}
                                        </TableCell>
                                        <TableCell style={{ width: this.props.windowWidth > 835 ? "28%" : "25%", color: 'white', fontSize: '11px' }}>
                                            DATE OF PURCHASE
                                            {this.state?.statusfi ? (
                                                <IoIosArrowUp size={16} className="pull-right" onClick={() => this.sortingFunc("created_at", "")} />
                                            ) : (
                                                <IoIosArrowDown size={16} className="pull-right" onClick={() => this.sortingFunc("created_at", "")} />
                                            )}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.renderTableData("type1")}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="pull-right">
                            {this.state.todosPerPage < this.state.memberLicenseData.length ?
                                <ul className="pagination pull-right paginat">

                                    <li>
                                        <span className="">Showing {(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + 1} -{this.state.currentPage * this.state.todosPerPage - this.state.memberLicenseData.length < 0 ? this.state.currentPage * this.state.todosPerPage : this.state.memberLicenseData.length}  of {this.state.memberLicenseData.length} enteries</span>
                                    </li>

                                    <li>
                                        <a
                                            style={{ pointerEvents: this.state.currentPage === 1 ? 'none' : '' }}
                                            onClick={this.state.currentPage == -1 + this.state.currentPage * this.state.todosPerPage ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage - 1, 'position')
                                            }
                                            aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                            <span className="sr-only">Previous</span>
                                        </a>
                                    </li>

                                    {this.renderTableData('pagination')}
                                    <li className="">
                                        <a className=""
                                            style={{ pointerEvents: Math.ceil(this.state.memberLicenseData.length / this.state.todosPerPage) === Number(this.state.currentPage) ? 'none' : '' }}
                                            onClick={this.state.currentPage * this.state.todosPerPage == this.state.memberLicenseData.length ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage + 1, 'position')
                                            }

                                            aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                            <span className="sr-only">Next</span>
                                        </a>
                                    </li>
                                </ul>
                                : null}
                        </div>

                    </div> </div>

            </div>
        </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        redux: state,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        backgroundScrollStop: (data) => dispatch({ type: ActionTypes.SCROLLSTOP, data: data }),

    };
};


// export default windowSize(connect(mapStateToProps, mapDispatchToProps)(Memberlicense)); 
export default connect(mapStateToProps, mapDispatchToProps)(Memberlicense); 